import { EVENT_STATES } from '../../../src/constants/constants'

function ratesCurrentlyAvailable(rates) {
  const currentTime = new Date().getTime() / 1000
  return rates?.nodes.some((rate) => {
    const rateAwaitingPreemtiveRateSoldOut = rates?.nodes.some(node => (
      node.id === rate.preemptiveRateId) && (node.capacity > 0
    ))
    // rate is available if not having future start stamp, and not awaiting preemptive rate sold out
    return (!rate.startStamp || rate.startStamp <= currentTime) && !rateAwaitingPreemtiveRateSoldOut
  })
}

const eventStateModel = (eventData) => {
  if (!eventData) return EVENT_STATES.noData

  // "regular" here means not locked, not soldAtDoor, not hidden etc.
  const ticketsSoldOut = eventData.soldOut
  const hasRegularRatesAvailable = eventData.rates?.nodes.length !== 0
  const hasOngoingOrFutureTimeSlots = eventData.totalAvailableTimeSlotCount !== 0
  const allTicketsLocked = !hasRegularRatesAvailable && eventData.rateStateExists?.locked
  const allTicketsAtDoor = !hasRegularRatesAvailable && eventData.rateStateExists?.soldAtDoor
  const allTicketsHidden = !hasRegularRatesAvailable && eventData.rateStateExists?.inactive
  const eventGeofenced = SSR_DATA.countryCode && eventData.availableCountries?.length &&
    !eventData.availableCountries?.includes(SSR_DATA.countryCode.toUpperCase())
  const { allowWaitlist, salesEnded } = eventData

  const anyRatesCurrentlyAvailable = ratesCurrentlyAvailable(eventData.rates)
  const ticketSalesStarted = (hasOngoingOrFutureTimeSlots && anyRatesCurrentlyAvailable)

  // note - there will soon be a "draft" type state where we will say smth like "ticket coming soon"
  if (eventData?.fanReminderPeriodActive && eventData.rateStateExists?.locked) {
    return EVENT_STATES.fanReminderWaitlistEnabledWithLockedTickets
  }
  if (eventData?.fanReminderPeriodActive) return EVENT_STATES.fanReminderWaitlistEnabled
  if (eventGeofenced) return EVENT_STATES.unavailableGeofenced
  if (eventData.state === 'EXPIRED' || !hasOngoingOrFutureTimeSlots) return EVENT_STATES.salesEndedEventOver
  if (salesEnded && eventData.rateStateExists?.locked) return EVENT_STATES.semiAvailableAllLocked
  if (salesEnded) return EVENT_STATES.salesEnded
  if (ticketsSoldOut && allowWaitlist) return EVENT_STATES.soldOutWaitlistEnabled
  if (ticketsSoldOut && !allowWaitlist) return EVENT_STATES.soldOutWaitlistNotEnabled
  if (allTicketsLocked) return EVENT_STATES.semiAvailableAllLocked
  if (allTicketsHidden) return EVENT_STATES.unavailableAllHidden
  if (allTicketsAtDoor) return EVENT_STATES.unavailableOnlyAtDoor
  if (!ticketSalesStarted) return EVENT_STATES.semiAvailableNotStarted

  return EVENT_STATES.availableStandard
}

export default eventStateModel
